import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Register from "../Register/Register";
import YowRegister from "../Register/YowRegister";
import Translate from "../../../Components/Multilanguage/Translate";
import moodBenefitsData from "./moodBenefits.json";

const BenefitRow = ({
	feature,
	benefits,
	selectedPlanIndex,
	onChoose,
	gridTemplateColumns,
}) => {

	const renderCell = (b) => {

		const feats = b?.features || [];

		const entry = feats.find((f) =>
			typeof f === "string"
				? f === feature.id
				: f && f.id === feature.id
		);

	

		if (
			entry &&
			entry.value !== undefined &&
			entry.value !== null
		) {
			return (
				<span className="price-text">
					{entry.value}
				</span>
			);
		}

		
		if (entry) {
			return (
				<span className="check">
					✓
				</span>
			);
		}

		

		return (
			<span className="dash">
				-
			</span>
		);
	};


	return (
		<div
			className="benefit-row"
			style={{
				gridTemplateColumns:
					gridTemplateColumns || `1fr ${benefits.map(() => "130px").join(" ")}`,
			}}
		>

			

			<div className="label">
				{feature.title}
			</div>



			{benefits.map((b, i) => (

				<div
					key={b.title + i}
					className={`col ${
						b?.choose_plan_required
							? "selectable-plan"
							: ""
					} ${
						b?.choose_plan_required && selectedPlanIndex === i
							? "selected-plan"
							: ""
					}`}
					onClick={
						b?.choose_plan_required
							? () => onChoose(i)
							: undefined
					}
				>
					{renderCell(b)}
				</div>

			))}

		</div>
	);
};


const Checkout2 = () => {

	const projectInfo = useSelector(
		(state) => state?.projectInfo?.value
	);

	const pubid = Number(projectInfo?.projectConfig?.pubid || projectInfo?.pubid);
	const hostname = (typeof window !== "undefined" && window?.location?.hostname) || "";
	const isMood =
		(pubid === 50132 && hostname.includes("mood.gizmott.com")) ||
		((hostname.includes("localhost") || hostname === "127.0.0.1") && pubid === 50132);

	const subscriber = isMood
		? moodBenefitsData
		: projectInfo
			?.projectConfig
			?.config
			?.SUBSCRIBER_BENEFITS;


	const features =
		subscriber?.features || [];


	const benefits =
		subscriber?.benefits || [];


	
	const initialSelected =
		benefits.findIndex(
			(b) => b?.choose_plan_required === true
		);

	const initialPlan =
		initialSelected >= 0
			? benefits[initialSelected]
			: null;

	const [
		selectedPlanIndex,
		setSelectedPlanIndex
	] = useState(
		initialSelected >= 0
			? initialSelected
			: -1
	);

	const [
		subscription_id,
		setSubscription_id
	] = useState(
		initialPlan?.subscription_id || ""
	);

	const [scrollbarMetrics, setScrollbarMetrics] = useState({
		thumbHeight: 0,
		thumbTop: 0,
		trackHeight: 0,
		trackTop: 0,
	});
	const benefitsScrollRef = useRef(null);
	const leftCardRef = useRef(null);
	const scrollbarTrackRef = useRef(null);
	const scrollbarDragRef = useRef(null);
	const shouldScrollBenefits = !isMood && features.length > 8;

	useEffect(() => {
		const benefitsScroll = benefitsScrollRef.current;

		if (!benefitsScroll || !shouldScrollBenefits) {
			return;
		}

		const updateBenefitsScrollState = () => {
			const leftCard = leftCardRef.current;
			if (!leftCard) return;

			const leftCardRect = leftCard.getBoundingClientRect();
			const benefitsScrollRect = benefitsScroll.getBoundingClientRect();
			const trackHeight = benefitsScroll.clientHeight;
			const maxScrollTop =
				benefitsScroll.scrollHeight - benefitsScroll.clientHeight;
			const thumbHeight = Math.max(
				28,
				(benefitsScroll.clientHeight / benefitsScroll.scrollHeight) *
					trackHeight
			);
			const maxThumbTop = Math.max(trackHeight - thumbHeight, 0);

			setScrollbarMetrics({
				thumbHeight,
				thumbTop: maxScrollTop
					? (benefitsScroll.scrollTop / maxScrollTop) * maxThumbTop
					: 0,
				trackHeight,
				trackTop: benefitsScrollRect.top - leftCardRect.top,
			});
		};

		updateBenefitsScrollState();
		benefitsScroll.addEventListener("scroll", updateBenefitsScrollState, {
			passive: true,
		});
		const observer = new ResizeObserver(updateBenefitsScrollState);
		observer.observe(benefitsScroll);
		observer.observe(leftCardRef.current);

		return () => {
			benefitsScroll.removeEventListener("scroll", updateBenefitsScrollState);
			observer.disconnect();
		};
	}, [shouldScrollBenefits]);

	const updateBenefitsScrollFromThumb = (clientY) => {
		const benefitsScroll = benefitsScrollRef.current;
		const track = scrollbarTrackRef.current;
		const dragState = scrollbarDragRef.current;

		if (!benefitsScroll || !track || !dragState) return;

		const maxScrollTop = benefitsScroll.scrollHeight - benefitsScroll.clientHeight;
		const maxThumbTop = track.clientHeight - scrollbarMetrics.thumbHeight;
		const thumbTop = Math.min(
			Math.max(0, dragState.thumbTop + clientY - dragState.clientY),
			maxThumbTop
		);

		benefitsScroll.scrollTop =
			maxThumbTop > 0 ? (thumbTop / maxThumbTop) * maxScrollTop : 0;
	};

	const handleScrollbarThumbPointerDown = (event) => {
		event.preventDefault();
		scrollbarDragRef.current = {
			clientY: event.clientY,
			thumbTop: scrollbarMetrics.thumbTop,
		};
		event.currentTarget.setPointerCapture(event.pointerId);
	};

	const handleScrollbarTrackPointerDown = (event) => {
		if (event.target !== event.currentTarget) return;

		const track = scrollbarTrackRef.current;
		const benefitsScroll = benefitsScrollRef.current;
		if (!track || !benefitsScroll) return;

		const maxScrollTop = benefitsScroll.scrollHeight - benefitsScroll.clientHeight;
		const maxThumbTop = track.clientHeight - scrollbarMetrics.thumbHeight;
		const thumbTop = Math.min(
			Math.max(0, event.clientY - track.getBoundingClientRect().top - scrollbarMetrics.thumbHeight / 2),
			maxThumbTop
		);

		benefitsScroll.scrollTop =
			maxThumbTop > 0 ? (thumbTop / maxThumbTop) * maxScrollTop : 0;
	};


	
	useEffect(() => {

		if (!benefits.length) {

			setSelectedPlanIndex(-1);
			setSubscription_id("");

			return;
		}



		if (
			selectedPlanIndex >= 0 &&
			selectedPlanIndex < benefits.length &&
			benefits[selectedPlanIndex]?.choose_plan_required
		) {
			setSubscription_id(
				benefits[selectedPlanIndex]?.subscription_id || ""
			);
			return;
		}


		
		const firstChoosePlan =
			benefits.findIndex(
				(b) => b?.choose_plan_required === true
			);


		if (firstChoosePlan >= 0) {

			setSelectedPlanIndex(
				firstChoosePlan
			);
			setSubscription_id(
				benefits[firstChoosePlan]?.subscription_id || ""
			);

		} else {

			setSelectedPlanIndex(-1);
			setSubscription_id("");

		}

	}, [
		benefits,
		selectedPlanIndex
	]);


	

	const onChoose = (index) => {

		setSelectedPlanIndex(index);
		const chosen = benefits[index];
		setSubscription_id(chosen?.subscription_id || "");

	};


	
	const getSelectedPlan = () => {

		if (
			selectedPlanIndex >= 0 &&
			selectedPlanIndex < benefits.length
		) {
			return benefits[selectedPlanIndex];
		}

		return null;
	};


	const selectedPlan =
		getSelectedPlan();



	if (
		projectInfo?.projectConfig?.pubid === 50187
	) {
		return <YowRegister />;
	}



	const isMobile =
		typeof window !== "undefined" && window.innerWidth < 768;

	const gridTemplateColumns =
		isMood && !isMobile
			? "minmax(320px, 1.8fr) 1fr 1fr"
			: isMood
				? "170px 130px 130px"
				: `1fr ${benefits.map(() => "130px").join(" ")}`;

	
	return (

		<div className={`checkout2-page ${isMood ? "mood-checkout" : ""}`}>

			<div className="checkout2-wrapper">

				
				<div ref={leftCardRef} className={`left-card ${isMood ? "mood-left-card" : ""}`}>


					
					<h2 className="title">

						<Translate
							textKey="plan_benefits"
						/>

					</h2>



					<div className="benefits-viewport">


						<div className="benefits-table">



							<div
								className={`benefits-header ${
									shouldScrollBenefits ? "has-scrollbar" : ""
								}`}
								style={{
									gridTemplateColumns:
										gridTemplateColumns,
								}}
							>


							

								<div className="label">
									&nbsp;
								</div>


								
								{benefits.map((b, i) => (

									<div
										key={b.title + i}
										className={`col ${
											b?.choose_plan_required
												? "selectable-plan"
												: ""
										} ${
											b?.choose_plan_required && selectedPlanIndex === i
												? "selected-plan"
												: ""
										}`}
										onClick={
											b?.choose_plan_required
												? () => onChoose(i)
												: undefined
										}
									>

										<div className="col-title">
											{b.title}
										</div>

										{(b?.sub_title || b?.subtitle) && (
											<div className="col-subtitle">
												{b.sub_title || b.subtitle}
											</div>
										)}

									</div>

								))}

							</div>


							

							<div
								ref={benefitsScrollRef}
								className={`benefits-scroll ${
									shouldScrollBenefits ? "is-scrollable" : ""
								}`}
							>


								{features.length > 0 ? (

									features.map((feature) => (

										<BenefitRow
											key={feature.id}
											feature={feature}
											benefits={benefits}
											selectedPlanIndex={
												selectedPlanIndex
											}
											onChoose={onChoose}
											gridTemplateColumns={
												gridTemplateColumns
											}
										/>

									))

								) : (

									<div
										className="benefit-row"
										style={{
											gridTemplateColumns:
												gridTemplateColumns,
										}}
									>

										<div className="label">
											No benefits available
										</div>

									</div>

								)}


							</div>


							<div
								className={`benefits-actions ${
									shouldScrollBenefits ? "has-scrollbar" : ""
								}`}
							>


								<div
									className="plan-actions"
									style={{
										gridTemplateColumns:
											gridTemplateColumns,
									}}
								>



									<div className="label">
										&nbsp;
									</div>



									{benefits.map((b, i) => (

										<div
											key={b.title + i}
											className="col"
										>

											{b?.choose_plan_required && (

												<button
													type="button"
													className={`choose-plan ${
														selectedPlanIndex === i
															? "active"
															: ""
													}`}
													onClick={() =>
														onChoose(i)
													}
												>

													{b?.cta_text || b?.ctaText || (
														<Translate
															textKey={
																"choose_plan_caps"
															}
														/>
													)}

												</button>

											)}

										</div>

									))}


								</div>


							</div>


						</div>


					</div>

					{shouldScrollBenefits && (
						<div
							ref={scrollbarTrackRef}
							className="checkout2-custom-scrollbar"
							style={{
								height: scrollbarMetrics.trackHeight,
								top: scrollbarMetrics.trackTop,
							}}
							onPointerDown={handleScrollbarTrackPointerDown}
						>
							<div
								className="checkout2-custom-scrollbar-thumb"
								style={{
									height: scrollbarMetrics.thumbHeight,
									transform: `translateY(${scrollbarMetrics.thumbTop}px)`,
								}}
								onPointerDown={handleScrollbarThumbPointerDown}
								onPointerMove={(event) => updateBenefitsScrollFromThumb(event.clientY)}
								onPointerUp={() => {
									scrollbarDragRef.current = null;
								}}
							/>
						</div>
					)}


				</div>


				
				<div className="right-panel">

					{(() => {

						const newCheckoutRequired =
							projectInfo
								?.projectConfig
								?.config
								?.WEBSITE_NEW_CHECKOUT_REQUIRED ===
							"true";


						

						if (
							selectedPlan &&
							(selectedPlan.go_to_checkout || subscription_id)
						) {

							return (
								<Register
									redirectPath={
										newCheckoutRequired
											? "/checkout"
											: "/subscription"
									}
									redirectState={
										isMood
											? {}
											: {
												subscription_id: subscription_id || selectedPlan?.subscription_id,
											}
									}
								/>
							);

						}


						

						return (
							<Register
								redirectPath="/home"
							/>
						);

					})()}

				</div>


			</div>

		</div>
	);
};


export default Checkout2;